import styled from 'styled-components';

export const Page = styled.div`
    width: 100vw;
    height:  100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #fff;

    .add-asset {
        padding: .5em 2em;
        margin-top: 1em;
    }
`

export const HeaderSection = styled.div`
    display: flex;
    align-items: center;
    min-width: 600px;
    width: ${props => props.width};
    justify-content: space-between;

    button.asset-type {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        background-color: #555;
        color: #fff;
    }
    .b-active {
        background-color: #3ee9f7 !important;
        color: #000 !important;
    }
       p.back {
            color: #ff3300;
    font-family: 'Roboto Condensed', sans-serif;
    font-style: italic;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 20px;
    width: 100%;
       }
`

export const Grid = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: start;
    width: ${props => props.width};
    height: ${props => props.height ? props.height : '60vh'};
    overflow-y: scroll;
    background-color: #2a2a2a;
    border-radius: 5px;
    padding: 20px;
    margin-top: 1.5em;

    p.no-assets {
        font: bold italic 26px 'Roboto Condensed';
        width: 100%;
        align-self: center;
        text-align: center;
    }
`

export const AssetItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: .5em 1em;
    border: ${props => props.border ? '1px solid #555' : 'none'};
    width: 200px;

    img {
        height: 80px;
        // width: 240px;

        :hover {transform: scale(1)}
    }

    p.asset-name {
        font: normal bold 13px 'Roboto Condensed';
        color: fff;
        text-align: center;
    }
`

export const ModalWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    background-color: #2a2a2a;
    padding-top: 2em;

    p.modal-title {font: italic bold 16px 'Roboto Condensed'}

    input {width: 70%;}

    form {
        display: inherit;
        flex-direction: column;
        align-items: center;
        height: 80%;
        width: 90%;
    }
`

export const VideoItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0.5em 1em;
    width: 250px;
    padding: 5px;
    border: ${props => props.border ? '1px solid #555' : 'none'};
    border-radius: 2px;

    &>div:first-child {
        width: 240px;
        height: auto
    }

    p.asset-name {
        font: normal bold 13px 'Roboto Condensed';
        color: fff;
        margin-top: .5em;
    }
    button.add-vimeo { padding: .25em 2em;
        margin-top: .125em;}
`

export const EditRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;

    button.edit-asset {
        height: 24px;
        padding: 0 1em;
        width: 80%;
    }

    i {font-size: 22px;
    color: #ff0033;}
`

export const CollectionInfo = styled.div`
    display: flex;
    align-items: flex-start;
    width: 80%;
    justify-content: center;
    margin-bottom: 2em;
    
    i {
        font-size: 36px;
        color: #ff0033;
        cursor: pointer;
    }
    div.collection-info {
        margin-right: 3em;

        h1.collection-name {
            font: bold italic 26px 'Roboto Condensed';
            text-transform: uppercase;
        }
        p.collection-description {
            font: bold normal 18px 'Roboto Condensed';
            text-align:center;
        }
    }
`


// WEBPACK FOOTER //
// ./src/pages/Admin/AssetCollections/AssetCollectionsNew/AssetCollections.styles.ts